import { useReactiveVar } from '@apollo/client'

import walletVar from '../apollo/vars/wallet'

const useWallet = () => {
  return useReactiveVar(walletVar.reactiveVar)
}

export default useWallet
